// extracted by mini-css-extract-plugin
export default {"container":"wj-z","blurb":"xj-z","links":"yj-z"};